// src/components/store/sections/blog-posts/BlogV58GlassauroraOceanCyan.tsx
"use client";

import React from "react";
import DynamicBlogVariant from "./DynamicBlogVariant";

export default function BlogV58GlassauroraOceanCyan(props: any) {
  return (
    <DynamicBlogVariant
      variantNumber={58}
      archKey="glass_aurora"
      archLabel="Frosted Glass Stories"
      palName="OceanCyan"
      grad="from-cyan-500 via-sky-500 to-blue-700"
      lightBg="bg-cyan-50"
      textCol="text-cyan-700"
      borderCol="border-cyan-200"
      btnCls="bg-blue-600 hover:bg-blue-700"
      hexCol="#06b6d4"
      {...props}
    />
  );
}
